// src/Header.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import menu, { home_menu } from 'view/JsonData/menu';
import { getMenuSettings } from './store/menuSettings';
import { getAdTags } from './store/adTags';

const Header = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [popUp, setPopUp] = useState(false)
    const [settingsPopUp, setSettingsPopUp] = useState(false)
    
    // Dynamic menu from database
    const headerMenus = useSelector(state => state.menuSettings?.headerMenus) || [];
    const popupMenus = useSelector(state => state.menuSettings?.popupMenus) || [];
    const settingsMenus = useSelector(state => state.menuSettings?.settingsMenus) || [];
    const menusLoading = useSelector(state => state.menuSettings?.menusLoading) || false;
    
    // Ad tags from database
    const adTags = useSelector(state => state.adTags?.tags) || [];
    const adTagsLoading = useSelector(state => state.adTags?.loading) || false;
    
    useEffect(() => {
        // Load saved language from localStorage on component mount
        const savedLanguage = localStorage.getItem('language');
        if (savedLanguage) {
            i18n.changeLanguage(savedLanguage);
        }
        // Load menu settings
        dispatch(getMenuSettings());
        // Load ad tags
        dispatch(getAdTags());
    }, [i18n, dispatch]);
    
    const changeLanguage = (language) => {
        // Save selected language to localStorage
        localStorage.setItem('language', language);
        i18n.changeLanguage(language);
    };
    
    const handleRoute =(item)=>{
        setPopUp(false)
        navigate(`${item.route}`)
    }
    
    const handleSettingsClick = () => {
        setSettingsPopUp(true);
    }
    
    const handleSettingsClose = () => {
        setSettingsPopUp(false);
    }
    
    const handleNavigateToSettings = () => {
        setSettingsPopUp(false);
        navigate('/settings');
    }
    
    // Get active ad tags by position
    const getAdTagsByPosition = (position) => {
        return adTags
            .filter(tag => tag.is_active === 1 && tag.position === position)
            .sort((a, b) => a.display_order - b.display_order);
    };
    
    // Render ad tags as HTML
    const renderAdTags = (tags) => {
        if (!tags || tags.length === 0) return null;
        
        return tags.map((tag) => (
            <div key={tag.id} dangerouslySetInnerHTML={{ __html: tag.tag_code }} />
        ));
    };
    
    return (
        <>
            {/* Header Top Ad Tags */}
            {renderAdTags(getAdTagsByPosition('header_top'))}
            
            <header className="ar_header_area_section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="ar_header_area">
                                {/* Header Left Ad Tags */}
                                {renderAdTags(getAdTagsByPosition('header_left'))}
                                
                                <div className="ar_header_navbar">
                                    <ul>
                                        {headerMenus.length > 0 ? (
                                            // Use dynamic menus from database
                                            headerMenus.map((item) => (
                                                <li key={item.menu_key}>
                                                    <a href="#" onClick={(e) => { e.preventDefault(); navigate(item.route); }}>
                                                        <img src="/images/game-ui/headerIcon.png" alt="header icon" />
                                                        {t(item.name)}
                                                    </a>
                                                </li>
                                            ))
                                        ) : (
                                            // Fallback to static menus
                                            <>
                                        <li><a href="#" onClick={(e) => { e.preventDefault(); navigate('/gold-market'); }}><img src="/images/game-ui/headerIcon.png" alt="header icon" />{t('Gold Market')}</a></li>
                                        <li><a href="#" onClick={(e) => { e.preventDefault(); navigate('/city'); }}><img src="/images/game-ui/headerIcon.png" alt="header icon" />{t('City')}</a></li>
                                        <li><a href="#" onClick={(e) => { e.preventDefault(); navigate('/pokemon-box'); }}><img src="/images/game-ui/headerIcon.png" alt="header icon" />{t('Pokemon Box')}</a></li>
                                        <li><a href="#" onClick={(e) => { e.preventDefault(); navigate('/backpack'); }}><img src="/images/game-ui/headerIcon.png" alt="header icon" />{t('Backpack')}</a></li>
                                            </>
                                        )}
                                    </ul>
                                </div>
                                <div className="ar_header_bars">
                                    <a href="#" onClick={(e) => { e.preventDefault(); handleSettingsClick(); }}><img src="/images/game-ui/sat.png" alt="settings" /></a>
                                    <a className="arMobileBars1" href="#" onClick={(e) => { e.preventDefault(); setPopUp(true); }}><img src="/images/game-ui/bars.png" alt="images" /></a>
                                    <a className="arMobileBars2" href="#" onClick={(e) => { e.preventDefault(); setPopUp(true); }}><img src="/images/game-ui/bars.png" alt="images" /></a>
                                </div>
                                
                                {/* Header Right Ad Tags */}
                                {renderAdTags(getAdTagsByPosition('header_right'))}
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            
            {/* Header Bottom Ad Tags */}
            {renderAdTags(getAdTagsByPosition('header_bottom'))}
            
            <Modal 
                show={popUp} 
                onHide={() => { setPopUp(false) }} 
                fullscreen
                contentClassName='menu-modal'
            >
                <div className="menu_expression">
                    <div className="container">
                        <div className="menu_main">
                            <h3>{t('Menu')}</h3>
                            <div className="menu_ul">
                                <ul>
                                    {popupMenus.length > 0 ? (
                                        // Use dynamic menus from database
                                        popupMenus.map((item) => (
                                            <li key={item.menu_key}>
                                                <a 
                                                    href="#" 
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        navigate(item.route);
                                                        setPopUp(false);
                                                    }}
                                                >
                                                    <img src="/images/menu/option-button.png" alt="" />
                                                    <p>{t(item.name)}</p>
                                                </a>
                                            </li>
                                        ))
                                    ) : (
                                        // Fallback to static menus
                                        <>
                                    {/* Home menu items */}
                                    {home_menu.map((item, index) => {
                                        return (
                                            <li key={`home-${index}`}>
                                                <a 
                                                    href="#" 
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        handleRoute(item);
                                                    }}
                                                >
                                                    <img src="/images/menu/option-button.png" alt="" />
                                                    <p>{t(item.name)}</p>
                                                </a>
                                            </li>
                                        );
                                    })}
                                    {/* Menu items from menu.js */}
                                    {menu.map((menuItem, menuIndex) => {
                                        return menuItem.child.map((childItem, childIndex) => {
                                            return (
                                                <li key={`menu-${menuIndex}-${childIndex}`}>
                                                    <a 
                                                        href="#" 
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            navigate(childItem.route);
                                                            setPopUp(false);
                                                        }}
                                                    >
                                                        <img src="/images/menu/option-button.png" alt="" />
                                                        <p>{t(childItem.name)}</p>
                                                    </a>
                                                </li>
                                            );
                                        });
                                    })}
                                        </>
                                    )}
                                </ul>
                            </div>
                            <a 
                                href="#" 
                                className="menu_close"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setPopUp(false);
                                }}
                            >
                                <img src="/images/menu/popup-close-button.png" alt={t('Close')} />
                            </a>
                        </div>
                    </div>
                </div>
            </Modal>
            
            {/* Settings Bottom Sheet Modal */}
            <Modal 
                show={settingsPopUp} 
                onHide={handleSettingsClose}
                fullscreen
                contentClassName='settings-modal'
            >
                <div className="menu_expression">
                    <div className="container">
                        <div className="menu_main">
                            <h3>{t('Settings')}</h3>
                            <div className="menu_ul">
                                <ul>
                                    <li>
                                        <a 
                                            href="#" 
                                            onClick={(e) => {
                                                e.preventDefault();
                                                changeLanguage('en');
                                            }}
                                        >
                                            <img src="/images/menu/option-button.png" alt="" />
                                            <p>{t('English')} {i18n.language === 'en' && '✓'}</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a 
                                            href="#" 
                                            onClick={(e) => {
                                                e.preventDefault();
                                                changeLanguage('he');
                                            }}
                                        >
                                            <img src="/images/menu/option-button.png" alt="" />
                                            <p>{t('Hebrew')} {i18n.language === 'he' && '✓'}</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a 
                                            href="#" 
                                            onClick={(e) => {
                                                e.preventDefault();
                                                changeLanguage('pt');
                                            }}
                                        >
                                            <img src="/images/menu/option-button.png" alt="" />
                                            <p>{t('Purtuguese')} {i18n.language === 'pt' && '✓'}</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a 
                                            href="#" 
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleNavigateToSettings();
                                            }}
                                        >
                                            <img src="/images/menu/option-button.png" alt="" />
                                            <p>{t('Go to Settings')}</p>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <a 
                                href="#" 
                                className="menu_close"
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleSettingsClose();
                                }}
                            >
                                <img src="/images/menu/popup-close-button.png" alt={t('Close')} />
                            </a>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default Header;